import {axios, HOST, config} from './settiing';

export default {
  /** vehicle api */
  getVehicleList() {
    return axios.get(`${HOST}/resource/vehicle`, config);
  },
  addVehicle(data) {
    return axios.post(`${HOST}/resource/vehicle`, data, config);
  },
  getVehicle(vehicleId) {
    return axios.get( `${HOST}/resource/vehicle/${vehicleId}`,  config)
  },
  updateVehicle(data) {
    return axios.put(`${HOST}/resource/vehicle`, data, config);
  },
  deleteVehicle(vehicleId) {
    return axios.delete(`${HOST}/resource/vehicle/${vehicleId}`, config);
  },

  deleteVehicles(vehicles) {
    return axios.post(`${HOST}/resource/vehicle/bulk/remove`, vehicles, config);
  },
  getVehiclesByDate(start, end) {
    return axios.get(`${HOST}/resource/vehicle/date/${start}/${end}`, config);
  },
  plateNoDulpCheck(data){
    return axios.get(`${HOST}/resource/vehicle/check/byPlateNo/${data}`, config);
  },
  getVehiclesByDriver(data){
    return axios.get(`${HOST}/resource/vehicle/byDriver/${data}`, config);
  },

  getVehicleDrivers(date, vehicleId, driverId) {
    return axios.get(`${HOST}/resource/vehicle/drivers/${date}/${vehicleId}/${driverId}`, config)
  },

  getVehicleAllDriver(vehicleId) {
    return axios.get(`${HOST}/resource/vehicle/drivers/${vehicleId}`,  config);
  },

  vehicleBulkRegist(data) {
    return axios.post(`${HOST}/resource/vehicle/bulk`, data, config);
  },

  getOdoDistanceInfo(vehicleId, start, end) {
    return axios.get(`${HOST}/resource/odo/statistic/${vehicleId}/${start}/${end}`, config);
  },
  updateObdDistanceLog(data) {
    return axios.put(`${HOST}/resource/odo`, data, config);
  },

  /** vehicle model api */
  getVehicleModelList() {
    return axios.get(`${HOST}/resource/vehicleModel`, config);
  },
  addVehicleModel(data) {
    return axios.post(`${HOST}/resource/vehicleModel`, data, config);
  },
  getVehicleModel(vehicleModelId) {
    return axios.get( `${HOST}/resource/vehicleModel/${vehicleModelId}`,  config)
  },
  updateVehicleModel(data) {
    return axios.put(`${HOST}/resource/vehicleModel`, data, config);
  },
  deleteVehicleModels(vehicleModels) {
    return axios.post(`${HOST}/resource/vehicleModel/bulk/remove`, vehicleModels, config);
  },
}